import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { setTrim } from '../../../../lib/common';
import RejectRegistrationProduct from '../../../../views/product/common/modal/RejectRegistrationProduct';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class RejectRegistrationProductModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 상품 거절 사유 타입
      type: 0,
      //--> 상품 거절
      reason: null,
    };
  }

  /**
   * 상품 승인 거절하기
   */
  onSubmit = () => {
    const { form, data, rejectRegistrationProduct } = this.props;
    const { type, reason } = this.state;
    const { productId, productUpdateLogId } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      rejectRegistrationProduct({
        productId,
        productUpdateLogId,
        type,
        reason: setTrim(reason),
      });

      /**
       *  모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'rejectRegistrationProduct', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <RejectRegistrationProduct
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.rejectRegistrationProduct.isOpen,
    data: state.product.rejectRegistrationProduct.data,
  };
};

const mapDispatchToProps = {
  rejectRegistrationProduct: productActions.rejectRegistrationProduct,
  toggleModal: productActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(RejectRegistrationProductModalContainer)));
